const AccessToken = function (tokenString, expiredTime) {
  this.tokenString = tokenString;
  this.expiredTime = expiredTime;
  this.isValid = function () {
    const now = new Date();
    const date = new Date(this.expiredTime * 1000);
    return now <= date;
  };
};

module.exports = AccessToken;
